export default __webpack_public_path__ + "1d6c449d7a0e180ce5b6be30cfcdd4ec.svg";